import type { Mailbox, Message } from "../api";
import type { RecipientDetails } from "../recipients";

function Addresses({ entries }: { entries: Mailbox[] }) {
  return <>{entries.map((mailbox, index) => (
    <span key={mailbox.address}>
      {index > 0 && ", "}
      {mailbox.name && mailbox.name !== mailbox.address ? <>{mailbox.name} &lt;{mailbox.address}&gt;</> : mailbox.address}
    </span>
  ))}</>;
}

export function MessageRecipients({ message, decoded }: { message: Message; decoded: RecipientDetails | null }) {
  const to = decoded?.to ?? message.to;
  const cc = decoded?.cc ?? message.cc;
  const bcc = decoded?.bcc ?? [];
  const incoming = message.location !== "sent";
  return (
    <div class="message-recipients" role="group" aria-label="Destinataires et livraison">
      <dl>
        <div class="recipient-row"><dt>À</dt><dd>{to.length ? <Addresses entries={to} /> : "Non indiqué dans l’en-tête"}</dd></div>
        {cc.length > 0 && <div class="recipient-row"><dt>Cc</dt><dd><Addresses entries={cc} /></dd></div>}
        {bcc.length > 0 && <div class="recipient-row"><dt>Cci</dt><dd><Addresses entries={bcc} /></dd></div>}
        {incoming && <div class="recipient-row recipient-delivered"><dt>Reçu pour</dt><dd>{message.address}</dd></div>}
        {incoming && Boolean(decoded?.delivery.length) && (
          <div class="recipient-row recipient-routing">
            <dt>Adresses d’acheminement</dt>
            <dd><ul>{decoded!.delivery.map((entry) => (
              <li key={entry.address}>{entry.address} <span class="recipient-source">({entry.sources.join(", ")})</span></li>
            ))}</ul></dd>
          </div>
        )}
      </dl>
      {incoming && (
        <p class="recipient-note">
          « Reçu pour » est l’adresse de réception dans cette application. Les autres adresses
          d’acheminement sont déclarées dans les en-têtes, sans garantie d’authenticité.
          Des destinataires peuvent rester invisibles, notamment les Cci et les copies livrées séparément.
        </p>
      )}
    </div>
  );
}
